module.exports = __webpack_public_path__ + "static/media/train.15d64360.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train.gif
// module id = 954
// module chunks = 0